import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { Link, useNavigate } from "react-router-dom";
import TenantContext from "../../../context/tenant/TenantContext";
import AuthContext from "../../../context/auth/AuthContext";
import LandLordContext from "../../../context/landlord/LandLordContext";
import Spinner from "../../../components/Spinner";
import Search from "../../../components/Search";

import searchicon from "../../../assets/img/s.png";
import locationicon from "../../../assets/img/location.png";
import nexticon from "../../../assets/img/back.png";
import checkicon from "../../../assets/img/check.png";
import backicon from "../../../assets/img/back.png";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { calculateNowTime } from "../../../services/sharedService";
import useTranslator from "../../../hooks/useTranslator";
import {
  convertCurrencyFormat,
  haveValue,
  getBaseUrl,
  validatePhoneNumber,
} from "../../../helper/common";
import { useCookies } from "react-cookie";
import { Modal, Row } from "react-bootstrap";
import { FaRegCopy } from "react-icons/fa6";
import { IoMdDownload } from "react-icons/io";
import copy from "copy-to-clipboard";
import QRCode from "react-qr-code";
import { Slider, styled } from "@mui/material";
import AssignTenantLLModal from "./AssignTenantLLModal";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import ProfileTable from "../../../components/Profiles/ProfilesTable";

function downloadBlob(blob, filename) {
  const objectUrl = URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = objectUrl;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  setTimeout(() => URL.revokeObjectURL(objectUrl), 5000);
}

const ProfileRequest = () => {
  const { _t } = useTranslator();
  const RentSlider = styled(Slider)({
    color: "#A3EB64",
    height: 8,
    "& .MuiSlider-track": {
      border: "none",
    },
    "& .MuiSlider-thumb": {
      height: 24,
      width: 24,
      backgroundColor: "#fff",
      border: "7px solid #253837",
      "&:focus, &:hover, &.Mui-active, &.Mui-focusVisible": {
        boxShadow: "inherit",
      },
      "&::before": {
        display: "none",
      },
    },
    "& .MuiSlider-valueLabel": {
      lineHeight: 1.2,
      fontSize: 9,
      background: "unset",
      padding: 0,
      width: 38,
      height: 38,
      borderRadius: "50% 50% 50% 0",
      backgroundColor: "#52af77",
      transformOrigin: "bottom left",
      transform: "translate(50%, -100%) rotate(-45deg) scale(0)",
      "&::before": { display: "none" },
      "&.MuiSlider-valueLabelOpen": {
        transform: "translate(50%, -100%) rotate(-45deg) scale(1)",
      },
      "& > *": {
        transform: "rotate(45deg)",
      },
    },
  });
  const marks = [
    {
      value: 1,
      label: "1%",
    },
    {
      value: 100,
      label: "100%",
    },
  ];

  const navigate = useNavigate();
  const authContext = useContext(AuthContext);
  const {
    loadUserTenant,
    user,
    userType,
    loadMyNotifications,
    updateUserInfo,
    checkIeDetails,
  } = authContext;

  const tenantContext = useContext(TenantContext);
  const { shareProfile } = tenantContext;

  const landLordContext = useContext(LandLordContext);
  const {
    loadAgencyProfile,
    loadProfilesLandlord,
    fullProfileReceived,
    basicProfileReceived,
    properties,
    loadProperties,
    sendInvitationToTenant,
  } = landLordContext;
  const [propertyFilter, setPropertyFilter] = useState("all");
  const [searchVal, setSearchVal] = useState("");
  const [rentPercentage, setRentPercentage] = useState(
    user?.rent_percentage ?? 1
  );
  const [rentValFrom, setRentValFrom] = useState(0);
  const [rentDoc, setRentDoc] = useState("current_annual_income");
  const [recordedSalary, setRecordedSalary] = useState({
    salary: 0,
    matched: 0,
  });

  const queryParameters = new URLSearchParams(window.location.search);

  //toggling between full and basic profile
  const [loading, setLoading] = useState(false);
  const [filteredFullProfiles, setFilteredFullProfiles] = useState([]);
  const [filteredBasicProfiles, setFilteredBasicProfiles] = useState([]);

  const [cookies, setCookie, removeCookie] = useCookies(["sharedProfileLink"]);
  const [isChanged, setIsChanged] = useState(false);
  const [effortRateModal, setEffortRateModal] = useState(false);

  const [filters, setFilters] = useState({
    createdAt: "desc",
    myScore: "",
  });

  const [assignLLModal, setAssignLLModal] = useState({
    tenant_id: null,
    openModal: false,
  });

  const [effortRatePecentage, setEffortRatePecentage] =
    useState(rentPercentage);

  useEffect(() => {
    let userid = localStorage.getItem("saveduserid");
    if (haveValue(user?._id) || haveValue(userid)) {
      useeffectfunc();
    }
    loadProperties(userid);
  }, [filters]);

  useEffect(() => {
    if (haveValue(user?.rent_percentage)) {
      setRentPercentage(user?.rent_percentage);
    }
    if (haveValue(user?.rent_from)) {
      setRentDoc(user?.rent_from);
    }
    useeffectfunc();
  }, [user]);

  // useEffect(() => {
  //   if (isChanged) handleChangeRent();
  // }, [rentDoc, rentPercentage]);

  const useeffectfunc = async () => {
    const sharedProfileLink = queryParameters.get("sharedProfileLink");
    const navigateTo = queryParameters.get("navigateTo");
    if (haveValue(navigateTo)) {
      navigate(`/${navigateTo}`);
    }
    if (haveValue(sharedProfileLink)) {
      await importProfileRedirect();
    } else {
      loadData();
    }
  };

  const loadData = () => {
    let userid = localStorage.getItem("saveduserid");
    if (user && user?._id) {
      setLoading(true);
      if (user?.isParentLL && haveValue(user?.agency_id)) {
        loadAgencyProfile(user?.agency_id)
          .then((res) => {
            setLoading(false);
          })
          .catch((err) => {
            console.log(err);
            setLoading(false);
          });
      } else {
        loadProfilesLandlord(user?._id, "full", filters)
          .then((res) => {
            setLoading(false);
          })
          .catch((err) => {
            console.log(err);
            setLoading(false);
          });
      }
      // loadProfilesLandlord(user?._id, "basic");
    }
    // else if (haveValue(userid)) {
    //   setLoading(true);
    //   loadProfilesLandlord(userid, "full", filters)
    //     .then((res) => {
    //       setLoading(false);
    //     })
    //     .catch((err) => {
    //       console.log(err);
    //       setLoading(false);
    //     });
    //   // loadProfilesLandlord(userid, "basic");
    // }

    loadMyNotifications(userid, userType);
  };

  const importProfileRedirect = async () => {
    let userid = localStorage.getItem("saveduserid");
    const sharedProfileLink = queryParameters.get("sharedProfileLink");

    if (haveValue(sharedProfileLink)) {
      const done = await shareProfile(
        sharedProfileLink,
        userid,
        "null",
        "full",
        { shareType: "tLink" }
      );
      removeCookie("sharedProfileLink", { maxAge: 1800 });
      if (done) {
        toast.success(_t("profileImported"));
      }
      loadData();
      navigate("/profile-request");
    }
  };

  useEffect(() => {
    setFilteredFullProfiles(fullProfileReceived);
    setFilteredBasicProfiles(basicProfileReceived);
  }, [fullProfileReceived, basicProfileReceived]);

  useEffect(() => {
    handleNewResult();
  }, [searchVal, propertyFilter]);

  const searchTenant = async (e) => {
    //console.log(e.target.value);

    let q = e.target.value;
    setSearchVal(q);
  };

  const handleFilterChange = (e) => {
    const val = e.target.value;
    setPropertyFilter(val);
  };

  const handleNewResult = () => {
    let all_result = [...fullProfileReceived];
    const queryText = searchVal?.toLowerCase()?.trim() || "";
    const normalize = (str) =>
      str
        ?.toString()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase()
        .replace(/[^\w\s]/gi, "")
        .trim();

    const normalizedQuery = normalize(queryText);
    const tokens = normalizedQuery.split(" ").filter(Boolean);

    if (haveValue(queryText)) {
      // Find matching property IDs
      const matchedPropertyIDs = properties
        .filter((prop) => {
          const combined = normalize(
            [
              prop?.street,
              prop?.street_number,
              prop?.staircase,
              prop?.floor_number,
              prop?.flat_number,
            ]
              .filter(Boolean)
              .join(" ")
          );
          return tokens.every((t) => combined.includes(t));
        })
        .map((p) => p?._id);

      all_result = all_result.filter((item) => {
        const fname = normalize(
          `${item?.tenantid?.fname ?? ""} ${item?.tenantid?.lname ?? ""}`
        );
        const hasNameMatch = tokens.every((t) => fname.includes(t));

        const propertyIds = item?.propertyid?.map((p) => p) || [];
        const hasPropertyMatch = propertyIds.some((id) =>
          matchedPropertyIDs.includes(id)
        );

        return hasNameMatch || hasPropertyMatch;
      });
    }

    /*
    if (haveValue(propertyFilter) && propertyFilter !== "all") {
      const all_prop_ids = all_result.map((item) =>
        item?.propertyid.map((item2) => item2)
      );
      all_result = all_result.filter((item, key) =>
        all_prop_ids[key].includes(propertyFilter)
      );
    }
    */

    setFilteredFullProfiles(all_result);
  };

  const handlecopyUrl = () => {
    copy(
      `https://${process.env.REACT_APP_URL_NAME}/home?requestProfileLink=${user?._id}`
    );
    toast.success(_t("linkCopied"));
  };

  const svgRef = useRef();

  const handleDownloadQR = useCallback(() => {
    const svg = svgRef.current.innerHTML;
    const blob = new Blob([svg], { type: "image/svg+xml" });
    downloadBlob(blob, `myimage.svg`);
  }, []);

  const calculateScore = (userDetails) => {
    var result = 0;

    if (checkIeDetails(userDetails)) {
      var totalScore =
        (userDetails?.paymentScores?.creditScore?.value || 0) / 2;

      if (userDetails?.is_university) {
        if (totalScore >= 600) {
          totalScore += 200;
        } else {
          totalScore += 400;
        }
      }
      if (totalScore > 850) {
        totalScore = 850;
      }
      result = totalScore;
    } else {
      if (haveValue(userDetails?.paymentScores?.creditScore?.value)) {
        result = userDetails?.paymentScores?.creditScore?.value;
      }
    }

    return result;
  };

  const checkSalary = (user) => {
    console.log(user, "NAMANCHECK");
    if (haveValue(user?.gurantor_id) && haveValue(user?.gurantor_id?._id)) {
      if (user?.gurantor_id?.algoanIncome) {
        let monthlyIncome = parseInt(
          user?.gurantor_id?.algoanIncome?.monthlyAmount
        );
        let recorded_annual_salary = monthlyIncome * 12;

        let userIncome = parseInt(
          haveValue(user?.gurantor_id?.current_annual_income)
            ? user?.gurantor_id?.current_annual_income
            : 0
        );
        let salaryMatch = Math.round(
          (recorded_annual_salary / userIncome) * 100
        );

        return {
          matched: salaryMatch,
          salary: recorded_annual_salary,
        };
      }
    } else {
      if (user?.algoanIncome) {
        let monthlyIncome = parseInt(user?.algoanIncome?.monthlyAmount);
        let recorded_annual_salary = monthlyIncome * 12;

        let userIncome = parseInt(
          haveValue(user.current_annual_income) ? user.current_annual_income : 0
        );
        let salaryMatch = Math.round(
          (recorded_annual_salary / userIncome) * 100
        );
        console.log(salaryMatch, recorded_annual_salary, "NAMANCHECK2");
        return {
          matched: salaryMatch,
          salary: recorded_annual_salary,
        };
      }
    }
  };

  const calculateRentAmount = (e, val) => {
    setRentPercentage(val);
    setIsChanged(true);
  };

  const changeEffortRatePercentage = (e, val) => {
    setEffortRatePecentage(val);
  };

  const handleEffortRateSubmit = (e) => {
    e.preventDefault();
    setEffortRateModal(false);
    setRentPercentage(effortRatePecentage);
    handleChangeRent();
  };

  const eachRentAmount = (fullProfile) => {
    if (
      haveValue(fullProfile?.rent_from_income) &&
      haveValue(fullProfile?.rent_percentage)
    ) {
      if (fullProfile?.rent_from_income == "current_annual_income") {
        return (
          convertCurrencyFormat(
            Math.floor(
              ((fullProfile?.tenantid?.current_annual_income || 0) *
                fullProfile?.rent_percentage) /
                1200
            )
          ) || 0
        );
      } else if (fullProfile?.rent_from_income == "itr_amount") {
        return (
          convertCurrencyFormat(
            Math.floor(
              ((fullProfile?.tenantid?.itr_amount || 0) *
                fullProfile?.rent_percentage) /
                1200
            )
          ) || 0
        );
      } else if (fullProfile?.rent_from_income == "recordedSalary") {
        const recordedSal = checkSalary(fullProfile?.tenantid);
        return (
          convertCurrencyFormat(
            Math.floor(
              ((recordedSal?.salary || 0) * fullProfile?.rent_percentage) / 1200
            )
          ) || 0
        );
      }
    } else {
      if (rentDoc == "current_annual_income") {
        return (
          convertCurrencyFormat(
            Math.floor(
              ((fullProfile?.tenantid?.current_annual_income || 0) *
                rentPercentage) /
                1200
            )
          ) || 0
        );
      } else if (rentDoc == "itr_amount") {
        return (
          convertCurrencyFormat(
            Math.floor(
              ((fullProfile?.tenantid?.itr_amount || 0) * rentPercentage) / 1200
            )
          ) || 0
        );
      } else if (rentDoc == "recordedSalary") {
        const recordedSal = checkSalary(fullProfile?.tenantid);
        return (
          convertCurrencyFormat(
            Math.floor(((recordedSal?.salary || 0) * rentPercentage) / 1200)
          ) || 0
        );
      }
    }
  };

  const handleChangeRent = () => {
    const temp_data = {
      rent_from: rentDoc,
      rent_percentage: effortRatePecentage,
    };
    updateUserInfo(temp_data)
      .then((res) => {
        let usertype = localStorage.getItem("usertype");
        loadUserTenant(usertype);
      })
      .catch((err) => {
        console.log("Error while updating user info");
      });
    // setIsChanged(false);
  };

  const filterChangeHandler = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    setFilters((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const openAssignLLModal = (tenant_id) => {
    setAssignLLModal((prev) => ({
      ...prev,
      tenant_id: tenant_id,
      openModal: true,
    }));
  };
  const handleCloseModal = () => {
    setAssignLLModal((prev) => ({
      ...prev,
      tenant_id: null,
      openModal: false,
    }));
  };

  if (loading) return <Spinner />;

  return (
    <>
      <div className="tabs-box-pattern tabs-box-pattern-2 big_tablebg">
        <div className="tabs-item d-block p-0">
          <div className="row">
            <div className="profile-page marless mobile-max-less mobile-max-lesshead">
              <div className="Search-bar searchbar_cls">
                <p className="percentage_salary_p search_heading01">
                  {_t("Search")}
                </p>
                <div className="search_bar_edit">
                  <input
                    type="text"
                    className="custom-input mb-0 input01"
                    onChange={searchTenant}
                    value={searchVal}
                    placeholder={_t("Search")}
                  />
                  <a href="#">
                    <img src={searchicon} alt="" />
                  </a>
                </div>
              </div>

              <div>
                <p className="percentage_salary_p search_heading01">
                  {_t("incomeFrom")}
                </p>
                <div className="table_option_set">
                  <select
                    name="rent_from_income_select"
                    id="rent_from_income_select borderset"
                    className="custom-input income_select"
                    onChange={(e) => setRentDoc(e.target.value)}
                    value={rentDoc}
                    style={{ width: "100%" }}
                  >
                    <option value="current_annual_income">
                      {" "}
                      {_t("annualIncome")}{" "}
                    </option>
                    <option value="itr_amount">
                      {_t("verifiedIncomeFromIRPF")}
                    </option>
                    <option value="recordedSalary">
                      {_t("verifiedAnnualIncome")}
                    </option>
                  </select>
                  <div
                    onClick={() => setEffortRateModal(true)}
                    className="rent-percentage cursor-pointer rent-percentage2"
                  >
                    {rentPercentage}%
                  </div>
                </div>
              </div>

              {/* <div>
                <p className="percentage_salary_p search_heading01">{_t("properties")}</p>
                <select
                  className="form-control row50"
                  name="link_property"
                  id="link_property"
                  onChange={handleFilterChange}
                  value={propertyFilter}
                >
                  <option value="all">{_t("allProperties")}</option>
                  {properties.map((prop, index) => (
                    <option value={prop._id}>
                      {prop.street} - {prop.street_number}, {prop.floor_number}-
                      {prop.flat_number}
                    </option>
                  ))}
                </select>
              </div> */}

              <div className="form-group">
                <p className="percentage_salary_p search_heading01">
                  {_t("ProfileCompletion")}
                </p>
                <select
                  className="form-control share-filter share-filter2"
                  name="myScore"
                  value={filters["myScore"]}
                  onChange={filterChangeHandler}
                >
                  <option value="">{_t("select")}</option>
                  <option value="0">0%</option>
                  <option value="25">25%</option>
                  <option value="50">50%</option>
                  <option value="75">75%</option>
                  <option value="100">100%</option>
                </select>
              </div>
            </div>
            {/* <div className="p-0">
              <div className="row max-rent-div mobile-max-rent-heading">
                <h4 className="">{_t("maxRent")}</h4>
                <div className="col-sm-6 row100">
                  <p className="percentage_salary_p search_heading01">{_t("incomeFrom")}</p>
                  <select
                    name="rent_from_income_select"
                    id="rent_from_income_select"
                    className="custom-input income_select"
                    onChange={(e) => setRentDoc(e.target.value)}
                    value={rentDoc}
                    style={{ width: "100%" }}
                  >
                    <option value="current_annual_income">
                      {" "}
                      {_t("annualIncome")}{" "}
                    </option>
                    <option value="itr_amount">
                      {_t("verifiedIncomeFromIRPF")}
                    </option>
                    <option value="recordedSalary">
                      {_t("verifiedAnnualIncome")}
                    </option>
                  </select>
                </div>
                <div className="col-sm-6">
                  <p className="percentage_salary_p search_heading01">
                    {_t("percentageOfRentFromSalary")}
                  </p>
                  <div className="d-flex justify-content-between">
                    <div className="col-sm-12">
                      <RentSlider
                        className="rent-slider"
                        defaultValue={rentPercentage}
                        aria-label="Default"
                        onChangeCommitted={calculateRentAmount}
                        valueLabelDisplay="on"
                        valueLabelFormat={(value) => `${value}%`}
                        marks={marks}
                        min={1}
                        max={100}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div> */}

            <ProfileTable
              profile={filteredFullProfiles}
              properties={properties}
              loadData={loadData}
              user={user}
              openAssignLLModal={openAssignLLModal}
            />
            {/* old table to show profiles */}
            {/* <div className="tabs-profile">
              <div className="tab-content" id="pills-tabContent">
                <div
                  className="tab-pane fade show active"
                  id="pills-home"
                  role="tabpanel"
                  aria-labelledby="pills-home-tab"
                >
                  <div className="edit-profile">
                    <div className="Notifications-row">
                      {filteredFullProfiles.length == 0 && (
                        <>
                          {" "}
                          <p style={{ textAlign: "center" }}>
                            {" "}
                            {_t("youHaveNotReceivedAnyFullProfilesYet")}
                          </p>
                        </>
                      )}

                      {filteredFullProfiles &&
                        filteredFullProfiles.map((fullProfile, index) => (
                          <>
                            <div
                              className="Notifications-wapper opacity-wapper px-0 setgridbarnotify row"
                              key={index}
                            >
                              <div className="leftyshare sharingcardblock col-md-5">
                                <h4>
                                  {fullProfile?.tenantid?.fname}{" "}
                                  {fullProfile?.tenantid?.lname}
                                  <span className="max-rent-span">
                                    {_t("maxRent")}:{" "}
                                    {eachRentAmount(fullProfile)}
                                    {haveValue(fullProfile?.rent_from_income) &&
                                    haveValue(fullProfile?.rent_percentage)
                                      ? ` [${fullProfile?.rent_percentage}%]`
                                      : ""}
                                  </span>
                                </h4>
                                <div className="row">
                                  <div className="col-sm-6">
                                    <p>
                                      {_t("skor")}:{" "}
                                      {haveValue(
                                        fullProfile?.tenantid?.gurantor_id
                                          ?.paymentScores
                                      )
                                        ? fullProfile?.tenantid?.gurantor_id
                                            ?.paymentScores?.creditScore?.value
                                        : calculateScore(fullProfile?.tenantid)}
                                    </p>
                                    <p>
                                      {_t("assignedProperties")}:{" "}
                                      {fullProfile?.propertyid?.length}
                                    </p>
                                  </div>
                                  <div className="col-sm-6">
                                    {user?.isParentLL && (
                                      <button
                                        className="btn btngreen assignToLLBtn"
                                        id="assignToLLBtn"
                                        onClick={(e) =>
                                          openAssignLLModal(
                                            fullProfile?.tenantid?._id
                                          )
                                        }
                                      >
                                        {_t(
                                          "assignToLandlord",
                                          "Button on landlord side in tenant profile listing page for Parent LL to share profile with another Sub LL"
                                        )}
                                      </button>
                                    )}
                                    <Link
                                      className="stripe-anchor"
                                      to={
                                        user?.isParentLL
                                          ? `/profile-property?agencylink=${fullProfile?._id}`
                                          : `/profile-property?sharedprofileid=${fullProfile?._id}`
                                      }
                                    ></Link>
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-3">
                                <div className="position-relative steps-progress-bar">
                                  <div class="circle">
                                    <div
                                      class="mask full"
                                      style={{
                                        transform: `rotate(${
                                          (fullProfile?.tenantid?.myScore ||
                                            0) * 1.8
                                        }deg)`,
                                      }}
                                    >
                                      <div
                                        class="fill"
                                        style={{
                                          transform: `rotate(${
                                            (fullProfile?.tenantid?.myScore ||
                                              0) * 1.8
                                          }deg)`,
                                        }}
                                      ></div>
                                    </div>
                                    <div class="mask half">
                                      <div
                                        class="fill"
                                        style={{
                                          transform: `rotate(${
                                            (fullProfile?.tenantid?.myScore ||
                                              0) * 1.8
                                          }deg)`,
                                        }}
                                      ></div>
                                    </div>
                                    <div class="inside-circle">
                                      {" "}
                                      {fullProfile?.tenantid?.myScore ||
                                        0}%{" "}
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div
                                onClick={(e) => {
                                  user?.isParentLL
                                    ? navigate(
                                        `/profile-property?agencylink=${fullProfile?._id}`
                                      )
                                    : navigate(
                                        `/profile-property?sharedprofileid=${fullProfile?._id}`
                                      );
                                }}
                                className="rytyshare col-md-4 cursor-pointer"
                              >
                                <div className="d-flex justify-content-center">
                                  <img src={nexticon} alt="" style={{}} />
                                </div>
                                <h6 className="mb-0">
                                  {calculateNowTime(fullProfile?.createdAt)}
                                </h6>
                              </div>
                            </div>
                          </>
                        ))}
                    </div>
                  </div>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </div>
      {assignLLModal.openModal && (
        <AssignTenantLLModal
          tenant_id={assignLLModal.tenant_id}
          openModal={assignLLModal.openModal}
          handleCloseModal={handleCloseModal}
        />
      )}
      <Modal
        show={effortRateModal}
        onHide={() => setEffortRateModal(false)}
        centered
        className="newmodalui asguarantor"
      >
        <Modal.Header closeButton>
          <Modal.Title>{_t("effortRate")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <div className="effortpopup-style">
              <p className="percentage_salary_p search_heading01">
                {_t("percentageOfRentFromSalary")}
              </p>
              <div className="d-flex justify-content-between rangemr-set mr-2">
                <div className="col-sm-12">
                  <RentSlider
                    className="rent-slider"
                    defaultValue={effortRatePecentage}
                    aria-label="Default"
                    onChangeCommitted={changeEffortRatePercentage}
                    valueLabelDisplay="on"
                    valueLabelFormat={(value) => `${value}%`}
                    marks={marks}
                    min={1}
                    max={100}
                  />
                </div>
              </div>
            </div>
            <button
              onClick={handleEffortRateSubmit}
              className="btn btnorange w-100"
              type="button"
            >
              {_t("submit")}
            </button>
          </div>
        </Modal.Body>
      </Modal>

      {/* <Modal
        show={linkedPropertiesModel}
        onHide={() => setLinkedPropertiesModel(false)}
        centered
        className="newmodalui asguarantor"
       >
        <Row className="card-listing mt-0">
          <div style={{ display: "flex" }}>
            <h4 className="titlebar_new">{_t("addOrRemoveProperty")}</h4>
            <div
              className="cursor-pointer"
              onClick={() => setLinkedPropertiesModel(false)}
            >
              <svg
                width="17"
                height="17"
                viewBox="0 0 17 17"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M16.7734 1.32064C16.8453 1.24881 16.9022 1.16352 16.9411 1.06966C16.98 0.975805 17 0.875207 17 0.773615C17 0.672022 16.98 0.571424 16.9411 0.477565C16.9022 0.383706 16.8453 0.298423 16.7734 0.226586C16.7016 0.15475 16.6163 0.0977657 16.5224 0.058888C16.4286 0.0200102 16.328 0 16.2264 0C16.1248 0 16.0242 0.0200102 15.9303 0.058888C15.8365 0.0977657 15.7512 0.15475 15.6794 0.226586L8.5 7.40749L1.32064 0.226586C1.24881 0.15475 1.16352 0.0977657 1.06966 0.058888C0.975805 0.0200102 0.875207 7.56923e-10 0.773615 0C0.672022 -7.56923e-10 0.571424 0.0200102 0.477565 0.058888C0.383706 0.0977657 0.298423 0.15475 0.226586 0.226586C0.15475 0.298423 0.0977657 0.383706 0.058888 0.477565C0.0200102 0.571424 -7.56923e-10 0.672022 0 0.773615C7.56923e-10 0.875207 0.0200102 0.975805 0.058888 1.06966C0.0977657 1.16352 0.15475 1.24881 0.226586 1.32064L7.40749 8.5L0.226586 15.6794C0.0815054 15.8244 0 16.0212 0 16.2264C0 16.4316 0.0815054 16.6283 0.226586 16.7734C0.371667 16.9185 0.568439 17 0.773615 17C0.97879 17 1.17556 16.9185 1.32064 16.7734L8.5 9.59251L15.6794 16.7734C15.8244 16.9185 16.0212 17 16.2264 17C16.4316 17 16.6283 16.9185 16.7734 16.7734C16.9185 16.6283 17 16.4316 17 16.2264C17 16.0212 16.9185 15.8244 16.7734 15.6794L9.59251 8.5L16.7734 1.32064Z"
                  fill="black"
                />
              </svg>
            </div>
          </div>
          

          {properties.map((property) => (
            <>
              <div
                className="paymentdeailbarleft"
                style={{ marginBottom: "12px" }}
              >
                <h3>{`${property?.street} - ${property?.street_number}, ${property.floor_number}-${property.flat_number}`}</h3>
              </div>
            </>
          ))}
        </Row>
      </Modal> */}
    </>
  );
};

export default ProfileRequest;
